import { render, staticRenderFns } from "./WantBuy.vue?vue&type=template&id=db9ae4ee&scoped=true"
import script from "./WantBuy.vue?vue&type=script&lang=js"
export * from "./WantBuy.vue?vue&type=script&lang=js"
import style0 from "./WantBuy.vue?vue&type=style&index=0&id=db9ae4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9ae4ee",
  null
  
)

export default component.exports